import React, { useState,useEffect } from 'react';
import { Field, FieldWrapper} from '@progress/kendo-react-form';
import {CusFormComboBox, FormInput, FormSubTitle, CusFormLabel, CusFormInput, FormComboBox, FormCheckbox, CusFormInput2} from '../validation/Form-Components';
import {blockValidator, buildingValidator, levelValidator, postalCodeValidator, requiredValidator, streetValidator, unitNoValidator, reqDDLValidator} from '../validation/Validators';
import service from '../services/ApiService';
import CusFormCheckbox from '../components/CusFormCheckbox';
import appDetailsData from '../data/applicantdetailsdata.json';
import CusRadioButton from '../components/CusRadioButton';
import titles from '../data/titles.json';
import marStatusArray from '../data/maritalstatus.json';
import helper from '../factory/Helper.js';
import ContactDetails from '../components/ContactDetails';
import MyInfoDetails from '../components/MyInfoDetails';
import ResiAddress from '../components/ResiAddress';
import { filterBy } from "@progress/kendo-data-query";
import ApplicantDtlsOccupation from '../components/ApplicantDtlsOccupation';
import countriesriskdashboard from '../data/countrieswealth.json';
import countriesDomicile from '../data/domicilecountries.json';
import config from '../appconfig/config.json';
import Loading from '../components/Loading.jsx';

const AuthPerson = (props) => {

    const{seq, applicantDetails, showDetails, hasMyInfo, formRenderProps, ...oth} = props;
    
    const numericRegex = new RegExp(/^[0-9]+$/);
    const getPersWealthCouOthValue = () => {
        if(applicantDetails.myInfo.PersWealthCou) {
            if(applicantDetails.myInfo.PersWealthCou.OTH){
                if(applicantDetails.myInfo.PersWealthCou.OTH === 'true') {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }

    const setMailingAddType = () => {
        let addType ='Y';
        if(applicantDetails.myInfo.MailAddrSameAsRes !== undefined) {
            if(applicantDetails.myInfo.MailAddrSameAsRes!==null) {
                addType = applicantDetails.myInfo.MailAddrSameAsRes;
            }
        }
        else {
            if(applicantDetails.myInfo.ResAddType === config.addTypeForeign) {
                addType = 'N';
            }
            else {
                addType = 'Y';
            }
        }
        return addType;
    }

    const [fCountriesRisk, setfCountriesRisk] = useState(countriesriskdashboard.slice());  //filtered countries
    const [fCountries, setfCountries] = useState(countriesDomicile.slice());  //filtered countries
  //  const [selectedRdoValue, setSelectedRdoValue] = useState(applicantDetails.myInfo.MailAddrSameAsRes? applicantDetails.myInfo.MailAddrSameAsRes!==null? applicantDetails.myInfo.MailAddrSameAsRes:applicantDetails.myInfo.ResAddType === config.addTypeForeign?'N':'Y':'Y'); //default to 'Y'
    const [selectedRdoPersWealthSGValue, setSelectedRdoPersWealthSGValue] = useState(applicantDetails.myInfo.PersWealthSG? applicantDetails.myInfo.PersWealthSG !==null?applicantDetails.myInfo.PersWealthSG:'Y':'Y'); 
    const [selectedRdoValue, setSelectedRdoValue] = useState(setMailingAddType())
    const [persWealthCouOth, setPersWealthCouOth] = useState(getPersWealthCouOthValue());

    const [isLoading,setIsLoading] = useState(false);

    useEffect(() => {
        console.log('@AuthPerson useEffect');
 
        if(hasMyInfo){
            formRenderProps.onChange('marStatusCbo'+seq, { value: helper.getObjInArray(applicantDetails.myInfo.MarStatus,marStatusArray) });
        }
    }, []);

    const handleRdoChange = React.useCallback(
        (e,id) => {
            setSelectedRdoValue(e.value);
            props.onRdoChange(e,id);
           
            if(formRenderProps.valueGetter("MailPostalCode"+seq) !== '') {
                formRenderProps.onChange('MailPostalCode'+seq, { value: '' });
            }
           
            formRenderProps.onChange('MailBlkNo'+seq,{value:''});
            formRenderProps.onChange('MailStreet'+seq,{value:''});
            formRenderProps.onChange('MailBldName'+seq,{value:''});
            formRenderProps.onChange('MailAddType'+seq, { value: '' });
            formRenderProps.onChange('MailFlrNum'+seq, { value: '' });
            formRenderProps.onChange('MailUnitNo'+seq, { value: '' });
        },
        [selectedRdoValue]
    );
 
    const handleRdoPersWealthSGChange= React.useCallback(
        (e,id) => {
            setSelectedRdoPersWealthSGValue(e.value);
            props.onRdoChange(e,id);
            formRenderProps.onChange('SG'+seq, { value: false });
            formRenderProps.onChange('BN'+seq, { value: false });
            formRenderProps.onChange('MY'+seq, { value: false });
            formRenderProps.onChange('CN'+seq, { value: false });
            formRenderProps.onChange('ID'+seq, { value: false });
            formRenderProps.onChange('IN'+seq, { value: false });
            formRenderProps.onChange('OTH'+seq, { value: false });
            formRenderProps.onChange('PersWealthOTH'+seq, { value: '' });
            setPersWealthCouOth(false);
        },
        [selectedRdoPersWealthSGValue]
    );

    const filterData = (filter) => {
        const data = countriesDomicile.slice();
        return filterBy(data, filter);
    };
    
    const filterChange = (event) => {
        setfCountries(filterData(event.filter));
    };

    const filterCountryRiskData = (filter) => {
        const data = countriesriskdashboard.slice();
        return filterBy(data, filter);
    };
    
    const filterCountryRiskChange = (event) => {
        setfCountriesRisk(filterCountryRiskData(event.filter));
    };

    const showErrMsg = React.useCallback(
        (msg) => {
            props.showErrMsg(msg);
        },[]
    );
  
    return(
        <div>
        {hasMyInfo?
        <div>
        {showDetails? 
                <MyInfoDetails applicantDetails={applicantDetails} holders={oth.holders} />
                : null}
        
                <Field leftLabelId={'lblTitle'+seq} leftLabelName={appDetailsData.titleDDL.lblname}
                    id={'titleCbo'+seq} name={'titleCbo'+seq}
                    component={CusFormComboBox} textField={'label'}
                    disabled={!applicantDetails.allowEdit}
                    data={titles} placeholder={'Please select'} validator={reqDDLValidator} />

                <Field leftLabelId={'lblMarStatus'+seq} leftLabelName={appDetailsData.marStatusDDL.lblname}
                    id={'marStatusCbo'+seq} name={'marStatusCbo'+seq}
                    component={CusFormComboBox} 
                    textField={'label'}
                    data={marStatusArray} 
                    dataItemKey="value"
                    disabled={!applicantDetails.allowEdit}
                    value={appDetailsData.marStatusDDL} placeholder={'Please select'}
                    validator={reqDDLValidator}/>

                    <Field leftLabelId={'lblCouOfDom'} leftLabelName={appDetailsData.label.countryOfDom}
                        id={'counOfDomicileCbo'+seq} name={'counOfDomicileCbo'+seq}
                        component={CusFormComboBox}
                        textField={'label'}
                        disabled={!applicantDetails.allowEdit}
                        data={fCountries}
                        filterable={true}
                        onFilterChange={filterChange}
                        placeholder={'Please select'}
                        validator={reqDDLValidator} />
 
                <ContactDetails seq={seq} fProps={formRenderProps} disabled={!applicantDetails.contactDtlEdit} showGreyLine={!oth.isPureSH || hasMyInfo} />

                <div style={{ paddingTop: "15px" }}> <hr className="greyPanelLine" /> </div>

                <Field component={FormSubTitle} id={'fstResidentialAddress'} name={appDetailsData.formSubTitle.ST2} />

                {applicantDetails.myInfo.ResAddType !== config.addTypeLocal?
                <div>
                <Field component={CusFormLabel} 
                    leftLabelId={'lblAddline1'+seq} leftLabelName={appDetailsData.label.addLine1}
                    id={'addline1'+seq} name={applicantDetails.myInfo.ResAddLine1 !==null? applicantDetails.myInfo.ResAddLine1:''}/>

                <Field component={CusFormLabel} 
                    leftLabelId={'lblAddline1'+seq} leftLabelName={appDetailsData.label.addLine2}
                    id={'addline1'+seq} name={applicantDetails.myInfo.ResAddLine2 !== null? applicantDetails.myInfo.ResAddLine2:''}/>
                </div>
                : 
                <ResiAddress applicantDetails={applicantDetails} />
                }

                {oth.isPureSH === false &&
                <div>

                <CusRadioButton name={"MailAddrSameAsRes"+seq} leftValue='Y' rightValue='N' 
                    disabled={!applicantDetails.allowEdit}
                    label={appDetailsData.label.sameAsRegBizAdd} onChange={handleRdoChange} 
                    checkedValue={selectedRdoValue} />

                {selectedRdoValue === 'N'? 
                    <div>
                    <div style={{ paddingTop: "15px" }}> <hr className="greyPanelLine" /> </div>

                    <Field component={FormSubTitle} id={'fstContactDetails'+seq} name={appDetailsData.formSubTitle.ST3} />  
                    <div className="row around-xs inputPair elementVisible">
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                            <div className="box" style={{ marginTop: "5px" }}>{appDetailsData.label.postalCode}</div>
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                            <div className="box">
                                <div style={{width:'90%', float:'left'}}>
                                    <Field className="k-textbox" name={'MailPostalCode'+seq} 
                                    maxLength={6} placeholder={'Please input'} component={FormInput} 
                                    validator={postalCodeValidator}  disabled={!applicantDetails.allowEdit}/>
                                </div>
                                <div style={{width:'10%', float:'left', textAlign:'center',paddingTop:'5px'}}>
                                    <a className="k-icon k-i-zoom" style={{fontSize:'24px'}} 
                                        onClick={(e)=>{
                                            e.preventDefault();
                                            let postcode= formRenderProps.valueGetter('MailPostalCode'+seq);
                                                  
                                            if(postcode === '' || postcode === undefined){
                                                showErrMsg('Postal Code is required');
                                                return;
                                            }
                                            else if(postcode.length > 6 || !numericRegex.test(postcode) ) {
                                                showErrMsg('Input max 6 numeric characters');
                                                return;
                                            }
                                            const params = {
                                                'postalCode': postcode
                                            }
                                            setIsLoading(true);
                                            service.getAddress(params.postalCode).then( res=> {
                                                // let data=JSON.parse(res.data.d);
                                                setIsLoading(false);
                                                let data= res.data.model[0];
                                                formRenderProps.onChange('MailPostalCode'+seq, { value: postcode });
                                                formRenderProps.onChange('MailBlkNo'+seq,{value:data.blK_NO});
                                                formRenderProps.onChange('MailStreet'+seq,{value:data.sT_NAME});
                                                formRenderProps.onChange('MailBldName'+seq,{value:data.bldG_NAME});
                                            })
                                            .catch(err => {
                                                setIsLoading(false);
                                                showErrMsg('Unable to retrieve the address.')
                                            });
                                        }}></a>
                                </div>
                            </div>
                        </div>
                    </div>
                   
                    
                    <Field component={CusFormInput2} 
                        leftLabelId={'lblMailBlkNo'+seq} leftLabelName={appDetailsData.label.blk} 
                        id={'MailBlkNo'+seq} name={'MailBlkNo'+seq} placeholder={'Please input'} 
                        disabled={!applicantDetails.allowEdit} 
                        maxLength={10} validator={blockValidator} /> 

                    <Field component={CusFormInput2} 
                        leftLabelId={'lblMailStreet'+seq} leftLabelName={appDetailsData.label.street} 
                        id={'MailStreet'+seq} name={'MailStreet'+seq} placeholder={'Please input'} 
                        disabled={!applicantDetails.allowEdit} 
                        maxLength={66} validator={streetValidator} />

                    <Field component={CusFormInput} 
                        leftLabelId={'lblMailFlrNum'+seq} leftLabelName={appDetailsData.label.level} 
                        id={'MailFlrNum'+seq} name={'MailFlrNum'+seq}  placeholder={'Please input'} 
                        disabled={!applicantDetails.allowEdit} 
                        maxLength={3} validator={levelValidator}  />

                    <Field component={CusFormInput} 
                        leftLabelId={'lblMailUnitNo'+seq} leftLabelName={appDetailsData.label.unitNo} 
                        id={'MailUnitNo'+seq} name={'MailUnitNo'+seq}  placeholder={'Please input'} 
                        disabled={!applicantDetails.allowEdit} 
                        maxLength={6} validator={unitNoValidator}  />

                    <Field component={CusFormInput} 
                        leftLabelId={'lblInputBld'+seq} leftLabelName={appDetailsData.label.building} 
                        id={'MailBldName'+seq} name={'MailBldName'+seq}  placeholder={'Please input'} 
                        disabled={!applicantDetails.allowEdit} 
                        maxLength={66} validator={buildingValidator}  />

                    <Field component={CusFormInput} 
                        leftLabelId={'lblMailCountry'+seq} leftLabelName={appDetailsData.label.country} 
                        id={'MailCountry'+seq} name={'MailCountry'+seq} disabled={true} />
                    {isLoading && <Loading />}
                    </div>
                :null}
                </div>}
                          
                <div style={{ paddingTop: "15px"  }}> <hr className="greyPanelLine" /> </div>

                <Field component={FormSubTitle} id={'fstST4'} name={appDetailsData.formSubTitle.ST4} />
       
                <ApplicantDtlsOccupation fProps={formRenderProps} seq={seq} array={applicantDetails.occupList} disabled={!applicantDetails.allowEdit} />
                                
                <FieldWrapper>
                    <CusRadioButton name={"PersWealthSG"+seq} leftValue='Y' rightValue='N' disabled={!applicantDetails.allowEdit} 
                        label={appDetailsData.label.persWealthSG} onChange={handleRdoPersWealthSGChange} checkedValue={selectedRdoPersWealthSGValue} />
                </FieldWrapper>     

                {selectedRdoPersWealthSGValue==='N' && <div>
                       <Field component={FormSubTitle} id={'fstContactDetails'+seq} name={appDetailsData.formSubTitle.ST5} />
                       <div className="row around-xs inputPair elementVisible" >
                            {appDetailsData.PersWealthCouChk.data.map((item, idx) => (
                                <CusFormCheckbox key={idx} id={item.id+seq} lblname={item.lblname} disabled={!applicantDetails.allowEdit}
                                    onCheckedChange={(checkedValue,id)=>{ }} />))}

                            <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6" style={{paddingTop:'10px'}}>
                                <div style={{width:'10%',float:'left'}}>
                                    <Field id={appDetailsData.PersWealthCouChk.others.id+seq} name={appDetailsData.PersWealthCouChk.others.id+seq} component={FormCheckbox} disabled={!applicantDetails.allowEdit}
                                        onChange={(e) => {
                                            setPersWealthCouOth(e.value);
                                            if(!e.value){
                                                formRenderProps.onChange('PersWealthOTH'+seq, { value: '' });
                                            }
                                        }
                                    } />
                                </div>
                                <div style={{width:'90%',float:'left',paddingTop:'10px'}} >
                                    <Field id={'PersWealthOTH'+seq} 
                                        name={'PersWealthOTH'+seq}
                                        placeholder={'Others'} 
                                        component={FormComboBox}
                                        textField={'label'}
                                        data={fCountriesRisk}
                                        filterable={true}
                                        onFilterChange={filterCountryRiskChange}
                                        disabled={!applicantDetails.allowEdit || !persWealthCouOth}
                                        validator={!persWealthCouOth? '':reqDDLValidator} />
                                </div>  
                            </div>
                            {/* China checkbox */}
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">  
                                <div style={{width:'8%',float:'left'}}>
                                    <Field id={appDetailsData.PersWealthCouChk.CN.id+seq} name={appDetailsData.PersWealthCouChk.CN.id+seq} component={FormCheckbox} disabled={!applicantDetails.allowEdit} />       
                                </div>
                                <div style={{width:'92%',float:'left'}}  className={'k-form-field'}>
                                    <label className={'k-checkbox-label'} >{appDetailsData.PersWealthCouChk.CN.lblname}</label>
                                </div>
                            </div>
                        </div>
                    </div> }
        </div> :
        <ContactDetails seq={seq} fProps={formRenderProps} disabled={!applicantDetails.allowEdit} />
        }
        </div>
    )
}

export default AuthPerson;